<template>
  <div class="resource-detail maxW" style="margin-top: 8%;">
    <!-- <div class="resource-nav-link">
      <router-link to="/home/resourceList">{{ $t('homepage.resource') }}</router-link>
      <strong>
        <i>></i>
        {{ resourceData.name }}.{{ resourceData.postfix }}
      </strong>
    </div> -->

    <nav-crumb :pathList="pathList" />
    <div class="resource-content clear">
      <div class="resource-content-c">
        <div class="resource-content-top clear">
          <img v-if="resourceData.file_type"
            :src="hostURL + '/static/index/images/format/resourceicon' + resourceData.file_type + '.png'"
            class="resource-icon" />
          <div class="resource-con-info clear">
            <div class="resource-box-l fl">
              <h2 class="resource-title">{{ resourceData.name }}.{{ resourceData.postfix }}</h2>
              <div class="create-info">
                <span class="creater-name">{{ resourceData.u_name }}</span>
                <em>
                  {{ $t('global.uploadTime') }}:
                  <i v-if="resourceData.create_time" class="create-time">{{ resourceData.create_time.slice(0, 10) }}</i>
                </em>
                <em>
                  {{ $t('global.size') }}：
                  <i class="file-size">{{ filesize }}</i>
                </em>
                <em>
                  {{ $t('global.score') }}：
                  <strong>
                    <i class="score">{{ resourceData.f_co_score }}</i>
                  </strong>
                </em>
                <ul class="resource-content-mid clear">
                  <li>
                    <i class="ipng icon_see"></i>
                    <em class="clicks">{{ resourceData.clicks == 0 ? '1' : resourceData.clicks }}
                      {{ $t('global.check') }}</em>
                  </li>
                  <!-- <li>
                                        <i class="ipng Collection07"></i
                                        ><em class="favourite"
                                            >{{ resourceData.f_count }}收藏</em
                                        >
                                    </li> -->
                  <li>
                    <i class="ipng download01"></i>
                    <em class="downloads">{{ resourceData.downloads }} {{ $t('global.download') }}</em>
                  </li>
                </ul>
              </div>
            </div>
            <el-button v-if="!(resourceData.postfix === 'mp4' && isTencentCloudVersion)" type="primary"
              class="download-btn fr" @click="downloadFile()">{{ $t('global.download') }}
            </el-button>
            <!-- <el-button class="share-btn fr"  @click="share"><img src="../../../assets/images/share_icon.png">{{
              $t('homepage.shareLink') }}</el-button> -->
            <sharePC :share.sync="shareLink" class="fr" style="margin: 15px  15px  0 0 ;" />
          </div>
        </div>
        <div class="resource-content-bottom">
          <template v-if="viewData.file_type == 3">
            <div class="imgBox">
              <img :src="viewData.src" @click="imgPreview(viewData.src)" />
            </div>
          </template>
          <template v-else-if="viewData.file_type == 1">
            <iframe :src="viewData.url" style="width:100%;height:500px"></iframe>
          </template>
          <template v-else-if="viewData.file_type == 2">
            <div class="common-box">viewData.content</div>
          </template>
          <template v-else-if="viewData.file_type == 5">
            <div class="common-box">
              <audioPlayer :audio-content="audioContent" ref="audioContent" />
            </div>
          </template>
          <template v-else-if="viewData.file_type == 6">
            <!-- <nativeVideo v-if="viewData.transform_status==1" :playParam.sync="playParam"></nativeVideo> -->
            <dplayerA style="height:100%;width:auto;" v-if="viewData.transform_status == 1" :playParam.sync="playParam">
            </dplayerA>
            <div v-else class="transform-loading">
              {{ $t('homepage.transcoding') }}
            </div>
          </template>
          <div class="empty-bgc-img" v-if="pleaceholder == true">
            <div class="resource-mask">
              <span>{{ tipWords }}</span>
            </div>
          </div>
        </div>
        <div class="resource-content-tool clear">
          <div class="mark fl">
            <span>{{ $t('global.score') }}</span>
            <el-rate v-if="isMark == false" :allow-half="true" :max="5" v-model="score" @change="addMark"></el-rate>
            <el-rate v-else :value="score / 2" :allow-half="true" :max="5" disabled></el-rate>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('homepage.shareLink')" class="share_dialog" :visible.sync="showShare" width="550px">
      <p class="share_text">{{ $t('global.copyUrlmessage') }}</p>
      <p class="share_text">
        <el-radio-group v-model="changeCopy" @change="getCopyVal">
          <el-radio :label="1">{{ $t('global.webUrl') }}</el-radio>
          <el-radio :label="2">{{ $t('global.H5Url') }}</el-radio>
        </el-radio-group>
      </p>
      <p class="share_link">{{ $t('global.linkUrl') }}：<a style="color:deepskyblue" href="#">{{ shareLink }}</a> </p>
      <div class="qrcode_container" id="qrcode" ref="qrcode" v-if="changeCopy === 2"></div>
      <el-button class="copy_btn" type="primary" @click="copyShareLink">{{ $t('global.copy') }}</el-button>
    </el-dialog>

    <image-viewer v-if="imagePreview.showViewer" :initial-index="imageIndex" :on-close="closeViewer"
      :url-list="imagePreview.previewSrcList">
    </image-viewer>
  </div>
</template>
<script>
import navCrumb from '@/components/common/navCrumb.vue';
// import nativeVideo from '@/components/common/nativeVideo';
import audioPlayer from '@/components/common/aplayer';
import dplayerA from '@/components/common/dplayerA.vue'
import { fail } from 'assert';
import QRCode from 'qrcodejs2'
import sharePC from "@/components/share.vue";
export default {
  components: {
    // nativeVideo,
    dplayerA,
    audioPlayer,
    navCrumb,
    sharePC
  },
  data() {
    return {
      pathList: [
        { path: '/home/resourceList', name: '资料' },
        { path: null, name: null }
      ],
      player: null, // 播放器
      isTencentCloud: sessionStorage.getItem('tencentCloud'), // 是否为腾讯云平台
      hostURL: '',
      userId: this.$g.user_id,
      resourceId: this.$route.query.id,
      resourceData: {}, // 资源数据
      filesize: '', //文件大小(带单位)
      score: 0, // 评分
      isMark: false, //是否已经评分
      isCollect: false, //是否已经收藏
      allowLoad: 1, //1允许下载，0不允许
      sectionId: null, //同类学段id
      gradeId: null, //同类年级id
      similarResourceData: [], //同类资源数组
      pleaceholder: false, //资源预览没数据的占位符
      tipWords: '', //资源预览提示语
      viewData: {}, //预览的数据
      playParam: {//视频预览
        play_url: ''
      },
      audioContent: {
        url: '',
        title: '试听',
        name: ''
      },
      clicksCount: 0,
      showShare: false, //显示分享弹窗
      shareLink: '', // 分享地址
      isShoreUrl: '',
      isShareLink: null,
      changeCopy: 1, // 选择复制
      videoSign: '',
      imagePreview: {
        showViewer: false,
        previewSrcList: []
      },
      imgViewUrl: '',
      shareLink: {
        img: '',
        name: '',
        notice: '',
        link: `${location.origin}/home/resourceDetail?id=${this.$route.query.id}&SharePC=true`,
        h5: `${location.origin}/wap/pages/resource/details?id=${this.$route.query.id}&SharePC=true`
      }
    };
  },
  created() {
    this.hostURL = sessionStorage.getItem('host_addr');
    // this.getViewURL();
    // this.getResource();
    this.checkPermission()
  },
  beforeDestroy() {
    sessionStorage.removeItem('SharePage')
  },
  mounted() { },
  computed: {

    // 是否是商学院本版
    isTencentCloudVersion() {
      return JSON.parse(window.sessionStorage.getItem('tencentCloud')) === 1
    },

    imageIndex() {
      return this.imagePreview.previewSrcList.indexOf(this.imgViewUrl);
    },
  },
  methods: {

    // 检测权限
    checkPermission() {
      let user_id = JSON.parse(sessionStorage.getItem("user_info_str"))
        ? JSON.parse(sessionStorage.getItem("user_info_str")).id
        : "";

      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll()
          this.$message.warning(this.$t("global.authorityMessage"));
          setTimeout(() => {
            // this.$router.replace("/");
            this.$router.push("/homeindex");
          }, 2500);
        } else {
          this.getViewURL();
          this.getResource();
          this.changeClick();
        }
      };

      if (user_id) {
        const type = this.$route.query.modelType || 3 // 从哪里来就传那个type值 如果没有就传3
        const type_id = this.$route.query.album_id || this.$route.query.id// 专辑id 或视频id
        this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
          params: { type, type_id, user_id },
          func: { success },
        });
      }
    },

    imgPreview(url) {
      this.imgViewUrl = url
      this.imagePreview.showViewer = true;
      this.imagePreview.previewSrcList = [url];
    },
    closeViewer() {
      this.imagePreview.showViewer = false;
    },
    // 根据资源id获取资源
    getResource() {
      let success = res => {
        // 检验是否有该资源权限
        // if (!res.data.length) {
        //   this.$router.push({
        //     path: '/homeindex'
        //   });
        //   this.$message.warning('暂无权限，请联系管理员')
        // }

        if (res?.data?.length === 0) { return }

        this.videoSign = res.data[0].resource_sign
        this.isShoreUrl = res.data[0].path
        this.isShareLink = res.data[0].is_share
        if (res.data.length != 0) {
          this.resourceData = res.data[0];

          this.shareLink.name = this.resourceData?.name || ''
          // this.shareLink.name = this.resourceData?.name || ''
          this.pathList[1].name = this.resourceData.name + '.' + this.resourceData.postfix
          // 转换一下文件大小：
          let size = res.data[0].filesize / 1024 / 1024;
          if (Math.floor(size) != 0) {
            this.filesize = Math.floor(size) + 'mb';
          } else {
            this.filesize = Math.floor(size * 1024) + 'kb';
          }
          // 判断当前这个资源是否已经收藏
          res.data[0].f_id == null ? (this.isCollect = false) : (this.isCollect = true);
          // 判断是否已对资源进行评分
          if (res.data[0].f_co_score == null) {
            this.isMark = false;
          } else {
            this.score = res.data[0].f_co_score;
            this.isMark = true;
          }
          //是否允许下载
          this.allowLoad = res.data[0].is_download;

          // 获取学段、年级的id
          this.sectionId = res.data[0].study_section_id;
          this.gradeId = res.data[0].grade_id;
          this.clicksCount = res.data[0].clicks;
          //获取 同类推荐 列表的数据
          // this.getSimilarResource(
          //     res.data[0].study_section_id,
          //     res.data[0].grade_id
          // );
        } else {
          this.$message.warning(this.$t('homepage.deleted'));
          this.$router.push('/home/resourceList');
        }
      };

      // 资料的来源 从专辑进来不需要传递is_limit = 1
      const album_id = this.$route.query.album_id
      const params = {
        id: this.resourceId,
        userid: this.userId,
        show_for_h5: 1,
      }

      if (!album_id) {
        params.is_limit = 1
      }

      this.$ajax({
        url: 'api/resource/resource',
        method: 'get',
        params: params,
        func: {
          success: success
        }
      });
    },
    // 修改点击次数
    changeClick() {
      let clicks = this.clicksCount;
      if (clicks == 0) {
        clicks++;
      }
      let success = data => { };
      this.$ajax({
        url: 'api/resource/resource',
        method: 'put',
        data: {
          id: this.resourceId,
          clicks: clicks + 1
        },
        func: {
          success: success
        }
      });
    },
    // 添加评分
    addMark() {
      //如果已评分了，就不能再评
      if (this.isMark == true) {
        return false;
      }
      if (this.userId == 0) {
        this.$message.warning(this.$t('homepage.needLogin'));
        return false;
      }
      let success = data => {
        this.$message.success(this.$t('global.successfullyScored'));
        this.getResource();
      };
      this.$ajax({
        url: 'api/comment/comment',
        method: 'post',
        data: {
          res_id: this.resourceId,
          user_id: this.userId,
          origin: 1,
          score: this.score * 2
        },
        func: {
          success: success
        }
      });
    },
    //收藏资源：
    collectResource() {
      if (this.userId == 0) {
        this.$message.warning(this.$t('homepage.needLogin'));
        return false;
      }
      let success = data => {
        if (this.isCollect == false && data.code == 200) {
          this.$message.success(this.$t('global.collect1'));
        } else {
          this.$message.success(this.$t('global.collect0'));
        }
        this.getResource();
      };
      if (this.isCollect == false) {
        this.$ajax({
          url: 'api/favourite/favourite',
          method: 'post',
          data: {
            res_id: this.resourceId,
            user_id: this.userId,
            origin: 1
          },
          func: {
            success: success
          }
        });
      } else {
        this.$ajax({
          url: 'api/favourite/favourite',
          method: 'delete',
          params: {
            res_id: this.resourceId,
            user_id: this.userId,
            origin: 1
          },
          func: {
            success: success
          }
        });
      }
    },
    // 下载：
    downloadFile() {
      if (this.allowLoad == 0) {
        this.$message.warning(this.$t('homepage.canotDown'));
      } else {
        window.location.href = this.hostURL + '/index/resource/resourcedownload?id=' + this.resourceId;
        this.addDownCounts();
      }
    },
    getCopyVal(val) {
      this.getShareLink();
      if (this.changeCopy === 2) {
        const timer = setTimeout(() => {
          clearTimeout(timer)
          this.initQrCode()
        }, 500)
      }
    },
    // 分享
    share() {
      if (this.isShareLink) {
        this.showShare = true;
        this.getShareLink();
      } else {
        this.$message.warning(this.$t('global.notAllowedShare'))
      }
    },
    initQrCode() {
      new QRCode('qrcode', {
        width: 200,
        height: 200,
        text: this.shareLink,
      })
    },
    getShareLink() {
      let success = data => {
        const webShare = `${location.origin}/home/resourceSharePage?id=${this.$route.query.id}&SharePC=true`;
        // const webShare = `${location.origin}/home/resourceSharePage?resource_sign=${this.videoSign}&id=${this.$route.query.id}&share=${data.data}&SharePage=true`;
        // const h5Share = `${location.origin}/wap/pages/resource/resource-share?resource_sign=${this.videoSign}&id=${this.$route.query.id}&share=${data.data}&SharePage=true`;
        const h5Share = `${location.origin}/wap/pages/resource/details?id=${this.$route.query.id}&SharePC=true`;
        this.shareLink = this.changeCopy === 1 ? webShare : h5Share;

      };
      this.$ajax({
        url: '/appapi/login/shareH5Url',
        method: 'get',
        data: {
          type: 1, // 模块类型：0：视频；1：资源；2：直播；3：专辑
          id: this.$route.query.id, // 资源id
        },
        func: {
          success: success
        }
      });
    },
    // 复制分享地址
    copyShareLink() {
      let input = document.createElement('input');
      input.value = this.shareLink;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.showShare = false;
      this.$message.success(this.$t('global.copySuccess'))
    },
    // 添加下载次数,type（1 资源    0 视频）
    addDownCounts() {
      let success = data => {
        this.getResource();
      };
      this.$ajax({
        url: 'index/resource/add_download_nums',
        method: 'post',
        data: {
          id: this.resourceId,
          userid: this.userId,
          type: 1
        },
        func: {
          success: success
        }
      });
    },
    // 获取同类资源
    getSimilarResource(sectionId, gradeId) {
      var array = {};
      array[0] = 'id';
      array[1] = 'create_time';
      array[2] = 'clicks';
      array[3] = 'downloads';
      var orderby = array[parseInt(4 * Math.random())];
      let success = data => {
        this.similarResourceData = data.data.rows;
      };
      this.$ajax({
        url: 'api/resource/resource',
        method: 'get',
        params: {
          data_type: 1,
          grade_id: gradeId,
          orderby: orderby,
          page: 1,
          size: 6,
          study_section_id: sectionId,
          not_in_file_type: 2,
          status: 1,
          authonity: 1
        },
        func: {
          success: success
        }
      });
    },
    // 换一批
    changeList() {
      this.getSimilarResource(this.sectionId, this.gradeId);
    },
    //获取资源预览的地址
    getViewURL() {
      let success = res => {
        if (is_empty(res.data)) {
          this.pleaceholder = true;
          this.tipWords = this.$t('homepage.onlyDown');
        } else {
          if (res.data.code == 404) {
            this.pleaceholder = true;
            this.tipWords = this.$t('homepage.transcoding');
          } else {
            this.viewData = res.data;
            if (res.data.file_type == 6) {
              //视频rtmp流
              if (Number(this.isTencentCloud)) {
                this.playParam.play_url = res.data.mp4url;
              } else {
                this.playParam.play_url = res.data.rtmpurl;
              }
            }
            if (res.data.file_type == 5) {
              //音频
              this.audioContent.url = res.data.mp3url;
            }
          }
        }
      };
      this.$ajax({
        url: 'api/resource/resource_view',
        method: 'get',
        params: {
          id: this.resourceId
        },
        func: {
          success: success
        }
      });
    },
  }
};
</script>

<style lang="scss">
.qrcode_container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.share_text {
  font-size: 16px;
  line-height: 25px;
  word-break: keep-all;

  .el-radio-group {
    margin: 20px 0 15px 0;
  }

  .el-radio__label {
    font-size: 15px;
  }
}

.tcp-skin .vjs-big-play-button .vjs-button-icon {
  display: none !important;
}

.video-js .vjs-big-play-button {
  display: none !important;
}

.video-js,
.vjs-custom-skin>.video-js {
  width: 100%;
  height: 100%;
}

.resource-nav-link {
  padding: 24px 0;
  font-size: 16px;

  a {
    color: #333;
  }

  i {
    margin: 0 6px;
  }

  strong {
    color: #999;
  }
}

.resource-content {
  padding-bottom: 40px;
}

.resource-content-c {
  // display: inline-block;
  // width: 70%;
  background-color: #fff;
  padding: 20px 30px;

  .resource-box-top {
    margin-bottom: 40px;
  }

  .resource-icon {
    max-width: 42px;
    max-height: 52px;
    overflow: hidden;
    float: left;
  }

  .resource-con-info {
    margin-left: 75px;
  }

  .resource-box-l {
    .resource-title {
      font-size: 18px;
      line-height: 20px;
      max-width: 500px;
    }

    .create-info {
      font-size: 12px;
      line-height: 16px;
      color: #888888;
      margin-top: 15px;
    }

    .creater-name {
      color: #020202;
      margin-right: 10px;
    }

    em {
      padding-right: 15px;
      padding: 0 10px;
      border-right: 1px solid #888;
      font-style: normal;

      &:last-of-type {
        border: 0 none;
      }
    }

    .score {
      color: #888888;
      // margin-left: 15px;
    }
  }

  .download-btn {
    margin-top: 10px;
    padding: 0;
    width: 80px;
    height: 36px;
    border: 0 none;
    background: #E62126;
  }

  .resource-content-mid {
    display: inline-block;
    margin-left: 39px;
    vertical-align: middle;

    li {
      display: inline-block;

      .icon_see {
        margin-right: 14px;
        width: 20px;
        height: 14px;
        background: url('../../../assets/images/shoucang@2x.png');
        background-size: contain;
      }

      .download01 {
        margin-right: 14px;
        width: 16px;
        height: 18px;
        background: url('../../../assets/images/download@2x.png');
        background-size: contain;
      }

      &:nth-child(2) {
        padding-left: 16px;
        border-left: 1px solid #979797;
      }
    }

    em {
      padding: 0 15px 0 0;
      color: #7693bd;
      line-height: 16px;
      border: 0 none;
      font-style: normal;
    }
  }

  .resource-content-bottom {
    margin-top: 20px;
    height: 500px;
    line-height: 500px;

    .imgBox {
      width: 100%;
      height: 100%;
      overflow: auto;
      text-align: center;
    }

    .empty-bgc-img {
      display: inline-block;
      width: 100%;
      height: 500px;
      background-image: url('../../../assets/images/moren@2x.png');
      background-size: 100% 100%;
      position: relative;

      .resource-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        text-align: center;
        visibility: hidden;
        opacity: 0;
        -moz-transition: all 0.35s ease-in;
        -webkit-transition: all 0.35s ease-in;
        -o-transition: all 0.35s ease-in;
        transition: all 0.35s ease-in;
      }

      &:hover .resource-mask {
        visibility: visible;
        opacity: 1;
      }

      span {
        font-size: 24px;
        color: #ffffff;
        background: rgba(0, 0, 0, 0.1);
        // border-radius: 15px;
        height: 50px;
        line-height: 50px;
        display: block;
        width: 370px;
        text-align: center;
        position: absolute;
        top: 45%;
        left: 50%;
        margin-left: -170px;
      }
    }

    .common-box {
      height: 100%;
      text-align: center;
      background-color: #a9cbe3;
      display: flex;
      align-items: center;
    }

    .transform-loading {
      display: flex;
      justify-content: center;
      font-size: 20px;
      color: #fff;
      background-color: #a9cbe3;
    }
  }

  .resource-content-tool {
    margin: 20px 0 0;

    .mark {

      span,
      .el-rate {
        vertical-align: middle;
        font-size: 14px;
      }

      .el-rate {
        display: inline;
        margin-left: 10px;
      }
    }

    .collect-share {
      .a-tit {
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        margin-right: 10px;
      }
    }

    .resource-collect {
      height: 28px;
      line-height: 28px;
      padding-right: 15px;
      font-size: 14px;

      .ipng {
        height: 16px;
        cursor: pointer;
        margin-left: 5px;
      }

      .collect {
        background-position: -465px -774px;
      }

      .uncollect {
        background-position: -440px -774px;
      }

      .line {
        border-right: 1px solid #b1bdc2;
        padding-left: 20px;
      }
    }
  }
}

.resource-content-r {
  display: inline-block;
  width: 22%;
  background-color: #fff;
  padding: 5px 10px;
  box-sizing: border-box;

  .resource-info-title {
    padding-bottom: 15px;

    .words {
      font-size: 14px;
      color: #666;
      line-height: 40px;
    }

    .words,
    .el-button {
      vertical-align: middle;
    }
  }

  .resource-info-li {
    margin-bottom: 30px;
    cursor: pointer;

    .file-img {
      display: block;
      max-width: 42px;
      max-height: 52px;
      overflow: hidden;

      img {
        display: inline-block;
        width: 100px;
        vertical-align: top;
      }
    }

    .file-text {
      margin-left: 50px;
      font-size: 12px;
      line-height: 16px;
    }

    .file-name {
      height: 30px;
      overflow: hidden;
      word-wrap: break-word;
      word-break: break-all;
    }

    .file-info {
      margin-top: 10px;
    }

    .download-count {
      margin-right: 10px;
      color: #666;
    }

    .section-info {
      color: #666;
    }
  }
}
</style>
